module.exports = __webpack_public_path__ + "img/clipboard-plus.4ab04987.svg";